import React from "react";
import { RouteObject } from "react-router-dom";

import {
  checkAnyScope,
  checkBooleanScope,
} from "../../../components/ScopeWrappers/helpers";
import { DataReconciliationDashboard } from "../../../domains/Dashboard/Pages/DataReconciliationDashboard/DataReconciliationDashboard";
import { DiscountsDashboard } from "../../../domains/Dashboard/Pages/DiscountsDashboard/DiscountsDashboard";
import { DASHBOARD_ROUTES } from "../../routes";

export const DashboardRoutes: RouteObject[] = [
  {
    path: DASHBOARD_ROUTES.Dashboard_Overview,
    lazy: async () => {
      const { OverviewDashboard } = await import(
        "../../../domains/Dashboard/Pages/OverviewDashboard/OverviewDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Overview}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={OverviewDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Profit,
    lazy: async () => {
      const { ProfitDashboard } = await import(
        "../../../domains/Dashboard/Pages/ProfitDashboard/ProfitDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Profit}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={ProfitDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Revenue,
    lazy: async () => {
      const { RevenueDashboard } = await import(
        "../../../domains/Dashboard/Pages/RevenueDashboard/RevenueDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Revenue}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={RevenueDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Shipping,
    lazy: async () => {
      const { ShippingDashboard } = await import(
        "../../../domains/Dashboard/Pages/ShippingDashboard/ShippingDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Shipping}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={ShippingDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Visitors,
    lazy: async () => {
      const { VisitorsDashboard } = await import(
        "../../../domains/Dashboard/Pages/VisitorsDashboard/VisitorsDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Visitors}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={VisitorsDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Orders,
    lazy: async () => {
      const { OrdersDashboard } = await import(
        "../../../domains/Dashboard/Pages/OrdersDashboard/OrdersDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Orders}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={OrdersDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_ProductGroups,
    lazy: async () => {
      const { ProductGroupsDashboard } = await import(
        "../../../domains/Dashboard/Pages/ProductGroupsDashboard/ProductGroupsDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_ProductGroups}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={ProductGroupsDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Trend,
    lazy: async () => {
      const { TimeSeriesDashboard } = await import(
        "../../../domains/Dashboard/Pages/TimeSeriesDashboard/TimeSeriesDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Trend}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={TimeSeriesDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_StatSig,
    lazy: async () => {
      const { StatSigDashboard } = await import(
        "../../../domains/Dashboard/Pages/StatSigDashboard/StatSigDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_StatSig}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={StatSigDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Discounts,
    lazy: async () => {
      const { DiscountsDashboard } = await import(
        "../../../domains/Dashboard/Pages/DiscountsDashboard/DiscountsDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Discounts}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={DiscountsDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Subscriptions,
    lazy: async () => {
      const { SubscriptionsDashboard } = await import(
        "../../../domains/Dashboard/Pages/SubscriptionsDashboard/SubscriptionsDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Subscriptions}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={SubscriptionsDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Discounts,
    lazy: async () => {
      const { DiscountsDashboard } = await import(
        "../../../domains/Dashboard/Pages/DiscountsDashboard/DiscountsDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Discounts}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("view_analytics", org.configurations),
              ])
            }
            children={DiscountsDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_AlwaysOn,
    lazy: async () => {
      const { SitewideDashboard } = await import(
        "../../../domains/Dashboard/Pages/AlwaysOnDashboard/SitewideDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_AlwaysOn}
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope(
                  "should_show_sitewide_dashboard",
                  org.configurations
                ),
              ])
            }
            children={SitewideDashboard}
          />
        ),
      };
    },
  },
  {
    path: DASHBOARD_ROUTES.Dashboard_Data_Reconciliation,
    lazy: async () => {
      const { DataReconciliationDashboard } = await import(
        "../../../domains/Dashboard/Pages/DataReconciliationDashboard/DataReconciliationDashboard"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={DASHBOARD_ROUTES.Dashboard_Data_Reconciliation}
            isEnabled={(org, isAdmin) =>
              checkAnyScope([
                isAdmin,
                checkBooleanScope(
                  "view_data_reconciliation_analytics",
                  org.configurations
                ),
              ])
            }
            children={DataReconciliationDashboard}
          />
        ),
      };
    },
  },
];
